import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  MessageSquare,
  LayoutGrid,
  Tag,
  Megaphone,
  RotateCcw,
  X,
  ChevronUp,
  HelpCircle,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function DemoMenu({
  onGo,
  onReset,
}: {
  onGo: (anchor: string) => void;
  onReset: () => void;
}) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const items: { label: string; icon: typeof LayoutGrid; action: () => void }[] = [
    { label: "The brief", icon: MessageSquare, action: () => onGo("brief") },
    { label: "Your plans", icon: LayoutGrid, action: () => onGo("plans") },
    { label: "What this is", icon: HelpCircle, action: () => onGo("how-it-works") },
    { label: "Pricing", icon: Tag, action: () => onGo("pricing") },
    { label: "Ad concepts", icon: Megaphone, action: () => navigate("/offsite-demo/ads") },
    { label: "Reset demo", icon: RotateCcw, action: onReset },
  ];

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col items-end gap-2">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 8, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.97 }}
            transition={{ duration: 0.18 }}
            className="w-56 rounded-2xl border border-border bg-card p-2 shadow-sm"
          >
            <p className="px-3 pt-1 pb-2 text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
              internal demo menu
            </p>
            {items.map((it) => (
              <button
                key={it.label}
                onClick={() => {
                  it.action();
                  setOpen(false);
                }}
                className="w-full flex items-center gap-3 px-3 py-2 rounded-xl text-sm text-foreground hover:bg-muted transition-colors text-left"
              >
                <it.icon size={15} className="text-muted-foreground" />
                {it.label}
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 rounded-full border border-border bg-card/90 backdrop-blur px-4 py-2 text-xs text-muted-foreground hover:text-foreground transition-colors"
        aria-label="Internal demo menu"
      >
        {open ? <X size={13} /> : <ChevronUp size={13} />}
        demo menu
      </button>
    </div>
  );
}
